import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbTableModule } from 'mdb-angular-ui-kit/table';
import { TradingSystem } from 'src/app/models/trading-system';
import { FrattaleService } from 'src/app/services/frattale.service';

@Component({
  selector: 'app-simulator',
  standalone: true,
  templateUrl: './simulator.component.html',
  styleUrls: ['./simulator.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, MdbFormsModule,
    MdbSelectModule, MdbTableModule
  ]
})
export class SimulatorComponent implements OnInit {

  headers = ['Market', 'verso', 'swing', 'dayweek', 'ora open', 'value', 'ora close', 'profit']
  headers2 = ['market', 'punti', 'num op', 'punti op', 'percpos', 'rawal', 'euro']
  tableData:any = []
  mesi: any = [
    {value: '1m', label: '1 mese'},
    {value: '3m', label: '3 mesi'},
    {value: '6m', label: '6 mesi'},
    {value: '1y', label: '1 anno'},
    {value: '2y', label: '2 anno'},
    {value: '3y', label: '3 anno'},
    {value: '5y', label: '5 anno'},
  ]
  tSys: any = []
  totaleEuro: number = 0

  formFiltri: FormGroup = new FormGroup({
    mesi: new FormControl('1y')
  })

  constructor(private service: FrattaleService) { }

  ngOnInit(): void {
    this.selezionaMese()
  }

  selezionaMese(){
    this.tSys = []
    let sim = this.formFiltri.get('mesi')?.value
    this.service.simulator(sim).subscribe((data: any) => {
      console.log(data)
      let dati: [] = data['data']
      this.tableData = dati
      let mkts = [...new Set(dati.map((item: any) => item.market))]
      console.log(mkts)

      mkts.forEach(mkt => {
        let arr: any = dati.filter((item: any) => item.market == mkt, mkt)
        let sum = arr.reduce((prev: any, curr: any) => {return parseFloat(curr.profit)+ parseFloat(prev)},0)
        let sumpos = arr.reduce((prev: any,curr: any) => {
          return curr.profit>0 ? +curr.profit + +prev : prev
        }, 0)
        let numpos2 = arr.reduce((prev: number,curr: any) => {
          return curr.profit>0 ? prev+1 : prev
        }, 0)
        let rawal = (sumpos/numpos2)/((sumpos-sum)/(arr.length-numpos2))
        let eur = arr.reduce((prev: any, curr: any) => {
          return curr.valeuro=='0' ? parseFloat(curr.profit)+prev : parseFloat(curr.profit)/parseFloat(curr.pip)/parseFloat(curr.valeuro)+prev
        },0)
        
        let ss: TradingSystem = {
          market: mkt,
          punti: sum,
          puntiop: sum/arr.length,
          puntipos: sumpos,
          numop: arr.length,
          numpos: numpos2,
          percpos: numpos2/arr.length,
          rawal: rawal,
          euro: eur
        }
        this.tSys.push(ss)
      })
      this.totaleEuro = this.tSys.reduce((prev: any, curr: any) => 
      { 
        return (curr.market.includes('DAX') || curr.market.includes('XNG')) ? prev : prev+curr.euro
      }
      , 0)
      console.log(this.tSys, dati)
    })
  }

}
